import { entity, list } from "./base";
import { concatModules } from "@/utility";
import utility from "@/utility";

const initialEntity = {
};

const inquiryEntityModule  = {
  state: {
    open: false,
    pk: null
  },
  mutations: {
    open(state, { pk }) {
      state.open = true;
      state.pk = pk;
    },
    close(state) {
      state.open = false;
      state.pk = null;
    }
  },
  actions: {
  },
  getters: {
    open(state) {
      return state.open;
    },
    pk(state) {
      return state.pk;
    }
  }
};

const inquiryListModule = {
  state: {
    tabIndex: 0 
  },
  mutations: {
    tabIndex(state, payload) {
      state.tabIndex = payload.value;
    },
    initialize(state) {
      state.entities = [];
      state.total = 0;
      state.page = 1;
      state.sort = {};
    },
  },
  actions: {
    updateTabIndex({ commit }, { value }) {
      commit("tabIndex", {
        value: value
      });
    },
    ongoing({ commit }, { ids}) {
      const store = this;

      commit("processing");

      return new Promise((resolve, reject) => {
        store.$axios // axios
          .put(`/inquiries/ongoing`, {
            params: {
              ids,
              status
            }
          })
          .then(() => {
            commit("processed");

            utility.$message({
              type: "success",
              message: "対応中に切り替えました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", { error });

            reject(error);
          });
      });
    },
    complete({ commit }, { ids}) {
      const store = this;

      commit("processing");

      return new Promise((resolve, reject) => {
        store.$axios // axios
          .put(`/inquiries/complete`, {
            params: {
              ids,
              status
            }
          })
          .then(() => {
            commit("processed");

            utility.$message({
              type: "success",
              message: "対応済に切り替えました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {
    tabIndex(state) {
      return state.tabIndex;
    }
  }
};

const entityModule = entity("inquiries", initialEntity);
const listModule = list("inquiries");

export const inquirie = {
  namespaced: true,
  modules: {
    list: concatModules(listModule, inquiryListModule),
    entity: concatModules(entityModule, inquiryEntityModule)
  }
};
